module.exports = __webpack_public_path__ + "media/images/ping/ping_verde-e5bb2601c6e2658937be32f27e218477.svg";